module.exports = __webpack_public_path__ + "static/media/gulp.76f37f77.svg";